import React, { PureComponent } from "react";
import cn from 'classnames';

import { changeLocation } from "../../../api/Location";
import chevronDropdown from "../../../containers/assets/chevron-down.svg";
import spinner from "../../../containers/assets/spinner.gif";
import Auth from "../../../routes/Auth";
import orderBy from "lodash/orderBy";
import EventEmitter from "../../../services/event-emitter";

class RoundSwitcherList extends PureComponent {
  setContentRef = content => (this.contentRef = content);
  setHeaderRef = content => (this.headerRef = content);

  constructor(props) {
    super(props);

    this.state = {
      showMenu: false,
      loading: false,
    };
    this.eventemitter = EventEmitter.getInstance();
  }

  isInstructor = () => {
    return Auth.isAnyInstructor();
  };

  handleClickOutside = e => {
    let clickedHeader = false;
    if (this.headerRef && this.headerRef.contains(e.target)) {
      clickedHeader = true;
    }

    let clickedContent = false;
    if (this.contentRef && this.contentRef.contains(e.target)) {
      clickedContent = true;
    }

    if (!clickedContent && !clickedHeader) {
      this.setState({ showMenu: false });
    }
  };

  changeRound = (round, current) => {
    const { location } = this.props;
    const { loading } = this.state;
    const { pathname } = location;

    if (loading === true) {
      return;
    }

    if (Number(round) === Number(current)) {
      this.setState({
        showMenu: false,
      });
      return;
    }

    const query = this.isInstructor()
      ? this.buildQuery({
        ...location.query,
        round: round + "",
      })
      : `round=${round}`;

    this.goToPathname(pathname, query);
  };

  goToPathname = (pathname, query) => {
    let url = pathname;
    if (url.indexOf('/onboarding') === 0) {
      url = '/onboarding';
    } else if (url.indexOf('/performance-feedback') === 0) {
      url = '/performance-feedback';
    } else if (url.indexOf('/analysis/team-reports') === 0) {
      url = '/analysis/team-reports';
    } else if (url.indexOf('/round-trivia') === 0) {
      url = '/round-trivia';
    }

    changeLocation(`${url}?${query}`);

    this.setState(
      {
        showMenu: false
      },
      () => {
        window.location.reload();
      }
    );
  }

  buildQuery = data => {
    let result = [];
    Object.keys(data).forEach(key => {
      result.push(
        `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
      );
    });

    return result.join("&");
  };

  componentDidMount() {
    if (window) {
      document.addEventListener("mousedown", this.handleClickOutside);
    }
  }

  componentWillUnmount() {
    if (window) {
      document.removeEventListener("mousedown", this.handleClickOutside);
    }
  }

  toggleMenu = () => {
    if (this.state.loading === true) {
      return;
    }

    this.setState(prevState => ({ showMenu: !prevState.showMenu }));
  };

  render() {
    const { currentRound, location, rounds, round, isMenuExpanded, ...rest } = this.props;
    const { showMenu, loading } = this.state;

    // Instructors (real or impersonating a student) see every round
    // sorted ascending — they need to jump to unstarted rounds for
    // round setup, previewing content, etc. Students see only rounds
    // whose start time has passed (past rounds + the currently-live
    // one).
    const years = this.isInstructor()
      ? orderBy(rounds, ["number"], ["asc"])
      : orderBy(rounds, ["number"], ["asc"]).filter(i => i.is_started === true);

    return (
      <div className={cn('round-switcher', {
        'round-switcher__hidden': !isMenuExpanded,
      })} {...rest}>
        <div className={"dropdown"}>
          <div
            className={"dropdown__header"}
            onClick={this.toggleMenu}
            ref={this.setHeaderRef}
          >
            Year {round}{" "}
            {!loading && (
              <img
                src={chevronDropdown}
                className="dropdown__icon"
                alt="Dropdown"
              />
            )}
            {loading && (
              <img
                src={spinner}
                className="dropdown__icon"
                alt="Dropdown"
              />
            )}
          </div>
          {showMenu && (
            <div className="dropdown__content" ref={this.setContentRef}>
              {years.map(year => (
                <div
                  key={year.id}
                  onClick={() => this.changeRound(year.number, round)}
                >
                  Year {year.number}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default RoundSwitcherList;



// WEBPACK FOOTER //
// ./src/components/navigation/leftbar/RoundSwitcherList.js